export default "https://cdn-static.gokick.com/assets/a067049b7600101c8dd9c58c97ab0ac81c37d227/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";